import catering from '../shared/catering.mjs';
export const { cateringSelections, cateringEvents } = catering;
